// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { RegistrarHoldingOperationsDelegation } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/HoldingOperationsDelegation';
import TemplateContract from '../../../../utils/TemplateContract';
import { useOperatorBasedQuery } from '../../useOperatorBasedQuery';

export const useRegistrarHoldingOperationsDelegations: () => UseQueryResult<
  TemplateContract<RegistrarHoldingOperationsDelegation>[],
  string
> = () =>
  useOperatorBasedQuery(
    'queryRegistrarHoldingOperationsDelegations',
    (ledgerApi, offset, operator) =>
      ledgerApi.queryRegistryRegistrarHoldingOperationsDelegations(offset, operator),
  );

const groupByDelegator = (data?: TemplateContract<RegistrarHoldingOperationsDelegation>[]) => {
  const res = {} as { [key: string]: TemplateContract<RegistrarHoldingOperationsDelegation> };
  (data || []).forEach((d) => {
    res[d.payload.delegator] = d;
  });
  return res;
};

export const useRegistrarHoldingOperationsDelegationsByParty = () => {
  const participantServicesQuery = useRegistrarHoldingOperationsDelegations();

  return groupByDelegator(participantServicesQuery.data);
};
